module.exports = "<div *ngIf=\"message\"\r\n     [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error', 'alert-warning': message.type === 'warning' }\">\r\n    <img *ngIf=\"message.type ==='warning'\" class=\"warning-image\" [src]=AlertWarning>\r\n    {{ message.text }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_directives/alert.component.html
// module id = ./src/app/_directives/alert.component.html
// module chunks = main